import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var baseColors = {
  // BLUE
  'blue-900': '#0052CC',
  'blue-800': '#2562EA',
  'blue-700': '#2A6CFF',
  'blue-600': '#3E7AFF',
  'blue-500': '#6695FF',
  'blue-400': '#94B4FF',
  'blue-300': '#B9CDFD',
  'blue-200': '#D0DDFE',
  'blue-100': '#DDE6FF',
  'blue-50': '#EBF1FF',
  'blue-0': '#F9FBFF',
  // NEUTRAL
  'neutral-900': '#172B4D',
  // Figma - neutral
  'neutral-800': '#1D3660',
  // Figma - black-600
  'neutral-700': '#354B71',
  // Figma - black-500
  'neutral-600': '#4C6083',
  // Figma - black-400 (secondary)
  'neutral-500': '#7E90B2',
  // Figma - black-300 (complementary)
  'neutral-400': '#B6C6E0',
  // Figma - black-200
  'neutral-300': '#C9D8EF',
  // Figma - black-100
  'neutral-200': '#E5ECF5',
  // Figma - black-80 (borders)
  'neutral-100': '#F2F5FD',
  // Figma - black-60
  'neutral-50': '#F5F8FE',
  'neutral-0': '#FFFFFF',
  // Figma - white
  // REDS
  'red-400': '#C92C22',
  'red-300': '#E04440',
  'red-200': '#EF5454',
  'red-100': '#F58B8B',
  'red-50': '#FFE6E6',
  // GREENS
  'green-300': '#1B7E37',
  'green-200': '#25B14D',
  'green-100': '#4CBE6C',
  'green-80': '#92D8A6',
  'green-50': '#E6F4EA',
  // ORANGES
  'orange-200': '#EE6002',
  'orange-100': '#FFA101',
  'orange-50': '#FFF2DF'
};
var functionalColors = {
  'brand-primary': baseColors['blue-700'],

  /** Stop using these values -------- */
  'accent-focus': baseColors['blue-600'],
  'accent-hover': baseColors['blue-800'],
  'accent-active': baseColors['blue-900'],
  'accent-disabled': baseColors['blue-400'],

  /** --------------------------------- */
  'accent-primary': baseColors['blue-700'],
  'accent-primary-hover': baseColors['blue-800'],
  'accent-primary-focus': baseColors['blue-800'],
  'accent-primary-active': baseColors['blue-900'],
  'accent-primary-disabled': baseColors['blue-400'],
  'accent-subtle': baseColors['neutral-500'],
  'accent-subtle-hover': baseColors['neutral-600'],
  'accent-subtle-focus': baseColors['neutral-600'],
  'accent-subtle-active': baseColors['neutral-700'],
  'accent-subtle-disabled': baseColors['neutral-300'],
  'accent-success': baseColors['green-100'],
  'accent-success-hover': baseColors['green-200'],
  'accent-success-focus': baseColors['green-200'],
  'accent-success-active': baseColors['green-300'],
  'accent-success-disabled': baseColors['green-80'],
  'accent-danger': baseColors['red-200'],
  'accent-danger-hover': baseColors['red-300'],
  'accent-danger-focus': baseColors['red-300'],
  'accent-danger-active': baseColors['red-400'],
  'accent-danger-disabled': baseColors['red-100'],
  'accent-warning': baseColors['orange-100'],
  'accent-info': baseColors['blue-700'],
  'text-primary': baseColors['neutral-900'],
  'text-secondary': baseColors['neutral-600'],
  'text-complementary': baseColors['neutral-500'],
  'text-invert': baseColors['neutral-0'],
  'text-placeholder': baseColors['neutral-400'],
  'text-info': baseColors['blue-800'],
  'text-success': baseColors['green-300'],
  'text-warning': baseColors['orange-200'],
  'text-danger': baseColors['red-400'],
  'background-primary': baseColors['neutral-0'],
  'background-secondary': baseColors['neutral-50'],
  'background-info': baseColors['blue-50'],
  'background-success': baseColors['green-50'],
  'background-warning': baseColors['orange-50'],
  'background-danger': baseColors['red-50'],
  'background-neutral': baseColors['neutral-200'],
  'control-border': baseColors['blue-300'],
  'control-background': baseColors['neutral-0'],
  'control-active-background': baseColors['neutral-100'],
  'control-active-border': baseColors['blue-700'],
  'control-invalid-border': baseColors['red-200'],
  'control-disabled': baseColors['blue-100'],
  'ui-border': baseColors['neutral-200'],
  'ui-navbar': baseColors['neutral-900'],
  'ui-navbar-text': baseColors['neutral-300'],
  'icon-primary': baseColors['neutral-400'],
  'icon-info': baseColors['blue-700'],
  'icon-success': baseColors['green-200'],
  'icon-warning': baseColors['orange-100'],
  'icon-danger': baseColors['red-200']
};

var themeColors = _objectSpread(_objectSpread({}, baseColors), functionalColors);

export { themeColors };